module.exports = __webpack_public_path__ + "img/img_18.ddd47c36.jpg";